import { QuestionSource } from "./types";

export const QUESTIONS_BY_DIFFICULTY: {
  [key in "Easy" | "Medium" | "Hard"]: QuestionSource[];
} = {
  Easy: [
    {
      text: "What does a pH meter measure?",
      correctAnswer: "Acidity",
      incorrectAnswers: ["Viscosity", "Color strength", "Water hardness"],
      explanation:
        "A pH meter determines the acidity or alkalinity of a formula (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which tool measures viscosity?",
      correctAnswer: "Brookfield viscometer",
      incorrectAnswers: [
        "Refractometer",
        "Conductivity probe",
        "Moisture analyzer",
      ],
      explanation:
        "Brookfield viscometers determine thickness and flow (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which measurement uses a graduated cylinder?",
      correctAnswer: "Volume",
      incorrectAnswers: ["Mass", "Hardness", "Light scattering"],
      explanation:
        "A graduated cylinder accurately measures liquid volume (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which piece of equipment heats formulas safely?",
      correctAnswer: "Hot plate",
      incorrectAnswers: ["Refractometer", "Salt bath", "Cooler unit"],
      explanation:
        "Hot plates provide controlled heating for formulations (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "What does a balance measure?",
      correctAnswer: "Weight",
      incorrectAnswers: ["pH", "Surface tension", "Opacity"],
      explanation: "A balance measures mass of raw materials (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which tool mixes small batches?",
      correctAnswer: "Overhead stirrer",
      incorrectAnswers: [
        "Colorimeter",
        "Conductivity meter",
        "Moisture balance",
      ],
      explanation: "Overhead stirrers blend ingredients evenly (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Why use a thermometer during batching?",
      correctAnswer: "Monitor temperature",
      incorrectAnswers: [
        "Measure viscosity",
        "Increase foam",
        "Improve scent stability",
      ],
      explanation: "Temperature affects emulsions and solubility (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which container is best for heating phases?",
      correctAnswer: "Beaker",
      incorrectAnswers: ["Test strip", "Petri dish", "Plastic bag"],
      explanation: "Beakers withstand heating and mixing (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "What do lab notebooks document?",
      correctAnswer: "Formulation data",
      incorrectAnswers: [
        "Marketing claims",
        "Shipping routes",
        "Packaging labels",
      ],
      explanation:
        "Lab notebooks record formulas, conditions and observations (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which method blends water and oil phases?",
      correctAnswer: "Emulsification",
      incorrectAnswers: ["Evaporation", "Electrolysis", "Distillation"],
      explanation: "Emulsification combines phases into an emulsion (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Why wear goggles in the lab?",
      correctAnswer: "Eye protection",
      incorrectAnswers: ["Boost accuracy", "Improve scent", "Brighten colors"],
      explanation: "Goggles protect eyes from splashes (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "What do stirring rods help with?",
      correctAnswer: "Mixing small samples",
      incorrectAnswers: ["Measuring pH", "Color grading", "Weighing powders"],
      explanation: "Rods allow manual mixing of small amounts (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which step follows weighing ingredients?",
      correctAnswer: "Batching",
      incorrectAnswers: ["Milling", "Sterilizing", "Label design"],
      explanation:
        "Batching means combining ingredients in correct order (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which instrument checks refractive index?",
      correctAnswer: "Refractometer",
      incorrectAnswers: ["Colorimeter", "pH probe", "Foam tester"],
      explanation:
        "Refractometers measure refractive index of solutions (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which sample type requires cleanliness?",
      correctAnswer: "All samples",
      incorrectAnswers: ["Oils only", "Colorants only", "Preservatives only"],
      explanation: "Clean equipment prevents contamination (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "What is tare weight?",
      correctAnswer: "Empty container weight",
      incorrectAnswers: ["Filled weight", "Water weight", "Final viscosity"],
      explanation:
        "Tare weight subtracts container mass from measurement (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Why are proper labels important?",
      correctAnswer: "Traceability",
      incorrectAnswers: ["Stronger foam", "Better gloss", "Better scent"],
      explanation: "Labels ensure formulas can be identified later (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which instrument determines color values?",
      correctAnswer: "Colorimeter",
      incorrectAnswers: ["Refractometer", "Conductivity meter", "Thermal bath"],
      explanation: "A colorimeter measures color intensity (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which liquid dissolves many cosmetic ingredients?",
      correctAnswer: "Water",
      incorrectAnswers: ["Propellant", "Wax", "Silicone resin"],
      explanation:
        "Water is the primary solvent in cosmetic formulas (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "Which tool measures solution conductivity?",
      correctAnswer: "Conductivity meter",
      incorrectAnswers: ["Viscometer", "pH strip", "Moisture analyzer"],
      explanation:
        "Conductivity meters measure ion content in water (Module 1)",
      difficulty: "Easy",
    },
    {
      text: "What starts the product development process?",
      correctAnswer: "Marketing brief",
      incorrectAnswers: ["Lab notebook", "Thermal bath", "Foam tester"],
      explanation:
        "A marketing brief outlines goals and target consumers (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What does a marketing brief define?",
      correctAnswer: "Product goals",
      incorrectAnswers: [
        "Viscosity range",
        "Wax melting point",
        "UV filter type",
      ],
      explanation:
        "Briefs describe claims, consumers, and positioning (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Which team creates product concepts?",
      correctAnswer: "Marketing",
      incorrectAnswers: ["Microbiology", "Liquid filling", "Carton printing"],
      explanation:
        "Marketing proposes ideas based on trends and needs (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Who develops the working formula?",
      correctAnswer: "R&D",
      incorrectAnswers: ["Sales", "Finance", "Regulatory"],
      explanation: "R&D translates concepts into formulas (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What do early prototypes test?",
      correctAnswer: "Feasibility",
      incorrectAnswers: ["Advertising art", "Tube cap colors", "Freight rates"],
      explanation:
        "Prototypes show whether the idea is technically possible (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What do claims communicate?",
      correctAnswer: "Product benefits",
      incorrectAnswers: [
        "Warehouse layout",
        "Payroll categories",
        "Cap torque",
      ],
      explanation: "Claims describe benefits consumers can expect (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Which team ensures regulatory compliance?",
      correctAnswer: "Regulatory",
      incorrectAnswers: ["Finance", "Procurement", "Maintenance"],
      explanation: "Regulatory reviews claims and ingredient limits (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Which document describes formula requirements?",
      correctAnswer: "Product brief",
      incorrectAnswers: ["Invoice", "Shipping manifest", "Catalog sheet"],
      explanation: "Product briefs outline needs for development (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What is a target cost?",
      correctAnswer: "Desired price",
      incorrectAnswers: [
        "Preservative dose",
        "Tube crimp width",
        "Scent solubility",
      ],
      explanation:
        "Target cost is the maximum acceptable cost per unit (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What does consumer testing evaluate?",
      correctAnswer: "User experience",
      incorrectAnswers: ["Batch viscosity", "pH drift", "Tank welds"],
      explanation:
        "Testing measures how real users perceive the product (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Why track deadlines in development?",
      correctAnswer: "Meet launch date",
      incorrectAnswers: ["Boost foam", "Reduce viscosity", "Increase redness"],
      explanation: "Deadlines keep teams aligned for launch targets (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Who approves final artwork?",
      correctAnswer: "Marketing",
      incorrectAnswers: [
        "Homogenizer tech",
        "Weighing staff",
        "Glassware washer",
      ],
      explanation: "Marketing ensures labels match product story (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Why meet with packaging early?",
      correctAnswer: "Compatibility",
      incorrectAnswers: ["Fragrance selection", "Foam height", "Tube gloss"],
      explanation:
        "Packaging must match formula behavior and filling needs (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Which team forecasts product demand?",
      correctAnswer: "Sales",
      incorrectAnswers: ["Microbiology", "Maintenance", "QC"],
      explanation: "Sellers predict expected order volumes (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Why involve procurement early?",
      correctAnswer: "Material sourcing",
      incorrectAnswers: ["Drop testing", "Batch timing", "Odor paneling"],
      explanation:
        "Procurement confirms lead times and raw material availability (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What ensures a product stands out?",
      correctAnswer: "Differentiation",
      incorrectAnswers: [
        "Stronger preservative",
        "Higher viscosity",
        "Deeper color",
      ],
      explanation: "Differentiation highlights unique benefits (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "Why evaluate competitive products?",
      correctAnswer: "Benchmarking",
      incorrectAnswers: ["Tube shaping", "Jar etching", "Cap threading"],
      explanation:
        "Benchmarking helps identify gaps and opportunities (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What does R&D deliver for scale-up?",
      correctAnswer: "Final formula",
      incorrectAnswers: ["Marketing tagline", "Tamper label", "Transit pallet"],
      explanation: "Scale-up requires a validated lab formula (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What team manages stability testing?",
      correctAnswer: "QC lab",
      incorrectAnswers: ["Finance", "Design agency", "Pallet shipping"],
      explanation: "QC oversees stability protocols and data (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What confirms the product is launch-ready?",
      correctAnswer: "Final approval",
      incorrectAnswers: ["Color swatch", "Foam record", "Ink density check"],
      explanation:
        "Launch approval confirms performance and compliance (Module 2)",
      difficulty: "Easy",
    },
    {
      text: "What does a humectant do?",
      correctAnswer: "Attracts water",
      incorrectAnswers: ["Add fragrance", "Boost pigment", "Increase foam"],
      explanation: "Humectants pull moisture from air or skin (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient softens the skin surface?",
      correctAnswer: "Emollient",
      incorrectAnswers: ["Preservative", "Colorant", "Emulsifier"],
      explanation: "Emollients smooth and soften skin feel (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "What does a chelating agent bind?",
      correctAnswer: "Metal ions",
      incorrectAnswers: ["Silicones", "Proteins", "Powders"],
      explanation:
        "Chelators tie up metals that destabilize formulas (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient helps oil mix with water?",
      correctAnswer: "Emulsifier",
      incorrectAnswers: ["Fragrance", "Colorant", "Abrasive"],
      explanation:
        "Emulsifiers allow oil and water phases to combine (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient prevents microbial growth?",
      correctAnswer: "Preservative",
      incorrectAnswers: ["Humectant", "Silicone", "Buffer"],
      explanation: "Preservatives stop bacteria, yeast and mold (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "What do silicones improve?",
      correctAnswer: "Slip",
      incorrectAnswers: ["Color depth", "Preservative load", "UV rating"],
      explanation: "Silicones provide lubricity and smooth feel (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which common solvent dissolves many materials?",
      correctAnswer: "Water",
      incorrectAnswers: ["Petrolatum", "Beeswax", "Iron oxide"],
      explanation: "Water is the primary solvent in cosmetics (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient thickens water-based formulas?",
      correctAnswer: "Carbomer",
      incorrectAnswers: ["Perfume", "Waxes", "Mica"],
      explanation: "Carbomer hydrates to create thick gels (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "What do surfactants reduce?",
      correctAnswer: "Surface tension",
      incorrectAnswers: ["Color shift", "Wax melting", "Fiber strength"],
      explanation: "Surfactants lower surface tension in cleansing (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient improves clarity in solutions?",
      correctAnswer: "Solubilizer",
      incorrectAnswers: ["Chelator", "Preservative", "Resin"],
      explanation:
        "Solubilizers help disperse oily materials clearly (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which material moisturizes by reducing water loss?",
      correctAnswer: "Occlusive",
      incorrectAnswers: ["Buffer", "Abrasive", "Binder"],
      explanation:
        "Occlusives create a barrier that slows evaporation (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient family enhances shine?",
      correctAnswer: "Silicones",
      incorrectAnswers: ["Clays", "Acids", "Starches"],
      explanation: "Silicones add gloss in hair and skin products (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which materials add color to formulas?",
      correctAnswer: "Colorants",
      incorrectAnswers: ["Surfactants", "Preservatives", "Waxes"],
      explanation: "Colorants provide pigmentation (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient controls pH?",
      correctAnswer: "pH adjuster",
      incorrectAnswers: ["Emollient", "Thickener", "Powder"],
      explanation: "pH adjusters raise or lower product acidity (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient keeps formulas from separating?",
      correctAnswer: "Stabilizer",
      incorrectAnswers: ["Humectant", "Abrasive", "Colorant"],
      explanation: "Stabilizers support uniformity and structure (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient gives products a scent?",
      correctAnswer: "Fragrance",
      incorrectAnswers: ["Salt", "Iron oxide", "Zinc stearate"],
      explanation: "Fragrances provide odor to formulas (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient improves skin feel quickly?",
      correctAnswer: "Silicone",
      incorrectAnswers: ["Polymer", "Preservative", "Clay"],
      explanation: "Silicones spread easily and enhance slip (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient is added to prevent oxidation?",
      correctAnswer: "Antioxidant",
      incorrectAnswers: ["Antifoam", "Chelator", "Mineral salt"],
      explanation: "Antioxidants delay rancidity and oxidation (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient boosts preservative performance?",
      correctAnswer: "EDTA",
      incorrectAnswers: ["Wax", "Mica", "Silicone"],
      explanation:
        "EDTA binds metals that reduce preservative effectiveness (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which material provides exfoliation?",
      correctAnswer: "Abrasive",
      incorrectAnswers: ["Solvent", "Fragrance", "Surfactant"],
      explanation: "Abrasive particles remove dead cells (Module 3)",
      difficulty: "Easy",
    },
    {
      text: "Which is the simplest cosmetic formulation type?",
      correctAnswer: "Solution",
      incorrectAnswers: ["Emulsion", "Ointment", "Stick"],
      explanation:
        "Solutions are simple homogeneous mixtures of soluble ingredients (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which product form is usually a thick cream?",
      correctAnswer: "Emulsion",
      incorrectAnswers: ["Powder", "Aerosol spray", "Tablet"],
      explanation:
        "Thick creams are typically oil in water emulsions (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is most often a clear liquid?",
      correctAnswer: "Solution",
      incorrectAnswers: ["Paste", "Stick", "Powder"],
      explanation:
        "Many shampoos and body washes are solution systems (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "What do emulsions combine into one product?",
      correctAnswer: "Oil and water",
      incorrectAnswers: [
        "Fragrance and dye",
        "Preservative and colorant",
        "Pigment and air",
      ],
      explanation:
        "Emulsions are stabilized mixtures of oil and water phases (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is typically used for lip balms?",
      correctAnswer: "Stick",
      incorrectAnswers: ["Solution", "Aerosol", "Tablet"],
      explanation: "Lip balms are usually high wax anhydrous sticks (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is usually a dry blended system?",
      correctAnswer: "Powder",
      incorrectAnswers: ["Emulsion", "Gel", "Ointment"],
      explanation:
        "Powders are made from blended solid particulates (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form relies on a gelling polymer?",
      correctAnswer: "Gel",
      incorrectAnswers: ["Stick", "Aerosol", "Tablet"],
      explanation:
        "Gels are structured with gelling polymers like carbomer (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which system uses a propellant to dispense product?",
      correctAnswer: "Aerosol",
      incorrectAnswers: ["Solution", "Gel", "Lotion"],
      explanation:
        "Aerosols rely on liquefied gases or compressed propellants (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which dosage form is compressed into a solid unit?",
      correctAnswer: "Tablet",
      incorrectAnswers: ["Gel", "Lotion", "Paste"],
      explanation:
        "Tablets are powders compressed into solid shapes (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is a pourable emulsion?",
      correctAnswer: "Lotion",
      incorrectAnswers: ["Stick", "Ointment", "Powder"],
      explanation:
        "Lotions are lower viscosity emulsions than creams (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is best for very occlusive products?",
      correctAnswer: "Ointment",
      incorrectAnswers: ["Aerosol", "Solution", "Powder"],
      explanation:
        "Ointments and pastes hold high levels of hydrophobic materials (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is common for perfume products?",
      correctAnswer: "Solution",
      incorrectAnswers: ["Stick", "Tablet", "Paste"],
      explanation: "Many fragrances are hydroalcoholic solutions (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form often suspends pigments in waxes?",
      correctAnswer: "Stick",
      incorrectAnswers: ["Solution", "Gel", "Aerosol"],
      explanation:
        "Sticks like lipsticks suspend pigments in wax and oils (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is convenient for dusting powders?",
      correctAnswer: "Loose powder",
      incorrectAnswers: ["Emulsion", "Gel", "Solution"],
      explanation:
        "Loose powders are used for body and face dusting (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form usually has the highest water content?",
      correctAnswer: "Solution",
      incorrectAnswers: ["Stick", "Ointment", "Pressed powder"],
      explanation: "Solutions are mostly water or aqueous solvent (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form spreads easily but is not runny?",
      correctAnswer: "Cream",
      incorrectAnswers: ["Tablet", "Aerosol", "Loose powder"],
      explanation:
        "Creams are semi-solid emulsions that still spread well (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is best for spray hair fixatives?",
      correctAnswer: "Aerosol",
      incorrectAnswers: ["Ointment", "Stick", "Pressed powder"],
      explanation:
        "Many hair sprays are aerosol solutions or emulsions (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which product form often needs suspending agents?",
      correctAnswer: "Gel",
      incorrectAnswers: ["Pressed powder", "Tablet", "Stick"],
      explanation:
        "Gels may suspend insoluble particles using polymers (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which form is common for antiperspirant sticks?",
      correctAnswer: "Stick",
      incorrectAnswers: ["Solution", "Gel", "Powder"],
      explanation: "Many antiperspirants use wax structured sticks (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "Which basic type includes shampoos and body washes?",
      correctAnswer: "Solutions",
      incorrectAnswers: ["Tablets", "Sticks", "Ointments"],
      explanation: "Many cleansers are solution-based systems (Module 4)",
      difficulty: "Easy",
    },
    {
      text: "What is the main function of shampoo?",
      correctAnswer: "Clean hair",
      incorrectAnswers: ["Color hair", "Relax curls", "Fix split ends"],
      explanation: "Shampoos remove soil and sebum from hair (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which products primarily detangle and soften hair?",
      correctAnswer: "Conditioners",
      incorrectAnswers: ["Aerosols", "Perfumes", "Toothpastes"],
      explanation: "Conditioners improve combing and softness (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which hair product mainly provides hold and style?",
      correctAnswer: "Styling product",
      incorrectAnswers: ["Shampoo", "Body lotion", "Sunscreen"],
      explanation:
        "Styling products give shape and hold to hairstyles (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which surfactants do most shampoos rely on?",
      correctAnswer: "Anionics",
      incorrectAnswers: ["Cationics", "Silicones", "Waxes"],
      explanation:
        "Anionic surfactants provide strong cleansing and foam (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient type improves wet combing?",
      correctAnswer: "Conditioning polymers",
      incorrectAnswers: ["Pearlescent pigments", "Preservatives", "UV filters"],
      explanation: "Cationic polymers and silicones aid combing (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which hair issue do anti-dandruff shampoos target?",
      correctAnswer: "Flaking scalp",
      incorrectAnswers: ["Split nails", "Chapped lips", "Sunburn"],
      explanation: "They reduce visible flakes and itch on scalp (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which hair type needs extra conditioning?",
      correctAnswer: "Damaged hair",
      incorrectAnswers: ["Very oily hair", "Short buzzcuts", "Wigs only"],
      explanation:
        "Chemically or physically damaged hair benefits from conditioning (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient gives slip in conditioners?",
      correctAnswer: "Silicones",
      incorrectAnswers: ["Salt", "Starch", "Zinc oxide"],
      explanation: "Silicones deposit on hair for slip and shine (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which product is usually used after shampoo?",
      correctAnswer: "Rinse conditioner",
      incorrectAnswers: ["Shave foam", "Toothpaste", "Body powder"],
      explanation:
        "Rinse conditioners follow shampoo to restore feel (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which hair product is used for strong hold spikes?",
      correctAnswer: "Styling gel",
      incorrectAnswers: ["Clarifying shampoo", "Hand lotion", "Facial scrub"],
      explanation: "Gels with resins create firm styles (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which problem do volumizing shampoos address?",
      correctAnswer: "Flat hair",
      incorrectAnswers: ["Too much curl", "Fading lipstick", "Sweaty feet"],
      explanation: "They aim to create fuller looking hair (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which category does hair spray belong to?",
      correctAnswer: "Styling product",
      incorrectAnswers: ["Cleanser", "Skin cream", "Deodorant"],
      explanation: "Hair sprays are classic styling aids (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient helps control foam quality in shampoo?",
      correctAnswer: "Surfactant blend",
      incorrectAnswers: [
        "Titanium dioxide",
        "Glycolic acid",
        "Zinc pyrithione",
      ],
      explanation: "Blending surfactants tunes foam and mildness (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which hair product is often left on hair?",
      correctAnswer: "Leave-in conditioner",
      incorrectAnswers: ["Anti-acne wash", "Mouthwash", "Shaving cream"],
      explanation: "Leave-in conditioners stay without rinsing (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which products are designed to add temporary color?",
      correctAnswer: "Hair colors",
      incorrectAnswers: ["Shampoos only", "Toothpastes", "Antiperspirants"],
      explanation:
        "Hair color products change hair shade temporarily or permanently (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient type strengthens hair films in styling?",
      correctAnswer: "Resins",
      incorrectAnswers: ["Preservatives", "Humectants", "Chelators"],
      explanation: "Film-forming polymers provide styling hold (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which product helps reduce frizz in humidity?",
      correctAnswer: "Anti-frizz serum",
      incorrectAnswers: ["Clarifying bar", "Bubble bath", "Nail polish"],
      explanation: "Serums often use silicones to control frizz (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which hair type often needs clarifying shampoos?",
      correctAnswer: "Product laden hair",
      incorrectAnswers: ["Virgin hair", "Shaved scalp", "Eyebrows"],
      explanation:
        "Clarifying shampoos remove heavy build-up residues (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which complaint do conditioners mainly address?",
      correctAnswer: "Dry feel",
      incorrectAnswers: ["Too much shine", "Lip dryness", "Underarm odor"],
      explanation: "Conditioners address dryness and rough feel (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which styling form is good for light control?",
      correctAnswer: "Mousse",
      incorrectAnswers: ["Bar soap", "Face mask", "Foot cream"],
      explanation: "Foam mousses give light hold and volume (Module 5)",
      difficulty: "Easy",
    },
    {
      text: "Which market segment includes facial moisturizers?",
      correctAnswer: "Skin care",
      incorrectAnswers: ["Hair care", "Oral care", "Color nails"],
      explanation:
        "Facial moisturizers belong to the skin care category (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which products primarily clean the skin surface?",
      correctAnswer: "Cleansers",
      incorrectAnswers: ["Antiperspirants", "Hair sprays", "Toothpastes"],
      explanation: "Cleansers remove dirt, oil and makeup (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which products aim to reduce wrinkles appearance?",
      correctAnswer: "Anti-aging creams",
      incorrectAnswers: ["Foot powders", "Shampoos", "Deodorant sticks"],
      explanation:
        "Anti-aging products target wrinkle and firmness concerns (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which product type protects against UV radiation?",
      correctAnswer: "Sunscreen",
      incorrectAnswers: ["Conditioner", "Mouthwash", "Shave cream"],
      explanation: "Sunscreens help prevent UV-induced skin damage (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which products are often used after shaving?",
      correctAnswer: "Aftershaves",
      incorrectAnswers: ["Shampoos", "Body scrubs", "Nail enamels"],
      explanation: "Aftershaves calm skin post shaving (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which problem do anti-acne products address?",
      correctAnswer: "Blemishes",
      incorrectAnswers: ["Dandruff", "Chapped lips", "Foot odor"],
      explanation:
        "They target comedones, pimples and related lesions (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient type hydrates skin by binding water?",
      correctAnswer: "Humectants",
      incorrectAnswers: ["Propellants", "Pigments", "Fillers"],
      explanation: "Humectants like glycerin bind water to skin (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredients form a barrier to reduce water loss?",
      correctAnswer: "Occlusives",
      incorrectAnswers: ["Peroxides", "Bleaches", "Chelators"],
      explanation: "Occlusives slow transepidermal water loss (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which product form is common for daily body moisturizers?",
      correctAnswer: "Lotion",
      incorrectAnswers: ["Tablet", "Loose powder", "Shave stick"],
      explanation: "Body lotions are fluid emulsions for daily use (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which products are mainly used for hand cleaning without water?",
      correctAnswer: "Hand sanitizers",
      incorrectAnswers: ["Deodorant sticks", "Foundation", "Hair masks"],
      explanation:
        "Hand sanitizers clean hands when soap is unavailable (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient type protects from UVB and UVA rays?",
      correctAnswer: "Sunscreen actives",
      incorrectAnswers: ["Fragrances", "Abrasives", "Colorants"],
      explanation:
        "Organic and inorganic UV filters absorb or reflect UV (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which skin type needs richer moisturizers?",
      correctAnswer: "Very dry skin",
      incorrectAnswers: ["Very oily skin", "Tattooed lips", "Scalp only"],
      explanation:
        "Dry skin benefits from higher oil and occlusives (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which cleanser format is traditional and solid?",
      correctAnswer: "Bar soap",
      incorrectAnswers: [
        "Hydroalcoholic spray",
        "Oil-in-oil emulsion",
        "Pressurized mousse",
      ],
      explanation: "Bar soaps are classic solid skin cleansers (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which product category includes shaving foams?",
      correctAnswer: "Skin care",
      incorrectAnswers: ["Hair color", "Oral care", "Nail care"],
      explanation: "Shaving foams are considered skin care products (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which skin care product targets uneven tone?",
      correctAnswer: "Brightening serum",
      incorrectAnswers: ["Foot powder", "Hair spray", "Lint roller"],
      explanation:
        "Brightening products address dark spots and tone (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient type reduces rough, flaky patches?",
      correctAnswer: "Exfoliants",
      incorrectAnswers: ["Propellants", "Gases", "Silicone antifoams"],
      explanation:
        "Chemical or physical exfoliants remove dead cells (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which product category fights razor bumps and irritation?",
      correctAnswer: "Post-shave treatments",
      incorrectAnswers: ["Lip glosses", "Nail lacquers", "Hair gels"],
      explanation:
        "Post-shave products soothe and protect irritated skin (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient family can stimulate collagen or turnover?",
      correctAnswer: "Actives",
      incorrectAnswers: ["Fillers", "Pigments", "Propellants"],
      explanation:
        "Actives like retinoids or peptides target biology (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which products are designed mainly for body moisturization?",
      correctAnswer: "Body lotions",
      incorrectAnswers: ["Tooth gels", "Brow pencils", "Deodorant sprays"],
      explanation: "Body lotions provide all-over moisturization (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which benefit do anti-acne cleansers often provide?",
      correctAnswer: "Oil control",
      incorrectAnswers: [
        "Hair straightening",
        "Lip plumping",
        "Nail hardening",
      ],
      explanation: "They reduce excess sebum and unclog pores (Module 6)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient gives shimmer in color cosmetics?",
      correctAnswer: "Mica",
      incorrectAnswers: ["Talc", "Silicone oil", "EDTA"],
      explanation: "Mica provides sparkle and light reflection (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product uses wax to structure color?",
      correctAnswer: "Lipstick",
      incorrectAnswers: ["Mousse", "Shampoo", "Gel"],
      explanation: "Lipsticks rely on wax networks for shape (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient improves slip in powders?",
      correctAnswer: "Talc",
      incorrectAnswers: ["Glycerin", "Iron oxide", "Sodium chloride"],
      explanation: "Talc reduces drag and enhances spread (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product darkens lashes?",
      correctAnswer: "Mascara",
      incorrectAnswers: ["Foundation", "Toner", "Shave cream"],
      explanation: "Mascara deposits pigments onto lashes (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which oxide provides red tones?",
      correctAnswer: "Iron oxide red",
      incorrectAnswers: ["Titanium dioxide", "Zinc oxide", "Magnesium sulfate"],
      explanation: "Red iron oxides create warm red hues (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product evens skin tone?",
      correctAnswer: "Foundation",
      incorrectAnswers: ["Shampoo", "Sunscreen", "Mouthwash"],
      explanation: "Foundations provide uniform pigmentation (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which pigment offers strong whitening?",
      correctAnswer: "Titanium dioxide",
      incorrectAnswers: ["Carbon black", "CI Blue 1", "Ferrous oxide"],
      explanation:
        "Titanium dioxide provides opacity and white coverage (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product adds facial color?",
      correctAnswer: "Blush",
      incorrectAnswers: ["Conditioner", "Soap", "Hair gel"],
      explanation: "Blush enhances cheek color using pigments (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What helps bind powder particles?",
      correctAnswer: "Binders",
      incorrectAnswers: ["Acids", "Fragrance oils", "Silicones"],
      explanation: "Binders hold pressed powders together (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product highlights cheekbones?",
      correctAnswer: "Highlighter",
      incorrectAnswers: ["Shaving foam", "Antiperspirant", "Hand lotion"],
      explanation: "Highlighters reflect light to accent features (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which process mixes large batches?",
      correctAnswer: "Scale-up",
      incorrectAnswers: ["Dry pressing", "Hot rolling", "Vacuum plating"],
      explanation: "Scale-up reproduces formulas in large volume (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "Which document outlines production steps?",
      correctAnswer: "Batch sheet",
      incorrectAnswers: ["Sales brief", "Ad claim sheet", "Invoice"],
      explanation: "Batch sheets define each manufacturing action (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What ensures even mixing?",
      correctAnswer: "Proper agitation",
      incorrectAnswers: [
        "Extra fragrance",
        "Thicker labels",
        "Lower fill speed",
      ],
      explanation: "Agitation distributes ingredients uniformly (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What measures batch temperature?",
      correctAnswer: "Thermocouple",
      incorrectAnswers: ["Viscometer", "HPLC column", "Refractometer"],
      explanation: "Temperature control is essential for production (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What is the purpose of in-process checks?",
      correctAnswer: "Verify consistency",
      incorrectAnswers: [
        "Improve smell",
        "Enhance color drift",
        "Rinse equipment only",
      ],
      explanation: "Checks ensure the batch matches expectations (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What equipment heats oil phases?",
      correctAnswer: "Hot plate",
      incorrectAnswers: ["Foam chamber", "Barcode reader", "Cartoner"],
      explanation: "A hot plate melts waxes and oils (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What helps prevent air entrapment?",
      correctAnswer: "Slow mixing",
      incorrectAnswers: ["Extra surfactant", "Glass packaging", "More pigment"],
      explanation: "Slower mixing reduces bubble formation (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What is used to weigh raw materials?",
      correctAnswer: "Balance",
      incorrectAnswers: ["pH meter", "Torque tester", "Gloss meter"],
      explanation: "Balances ensure accurate ingredient dosing (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What must match for consistent batches?",
      correctAnswer: "Process parameters",
      incorrectAnswers: ["Pump color", "Carton gloss", "Tube diameter"],
      explanation:
        "Consistency requires identical mixing conditions (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "Which test predicts product lifespan?",
      correctAnswer: "Stability testing",
      incorrectAnswers: ["Claims review", "Barcode scan", "Tube crimping"],
      explanation: "Stability tests reveal long-term behavior (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What ingredient gives makeup its color?",
      correctAnswer: "Pigments",
      incorrectAnswers: ["Silicones", "Preservatives", "Chelators"],
      explanation: "Pigments provide shade and opacity in cosmetics (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which mineral gives shimmer in makeup?",
      correctAnswer: "Mica",
      incorrectAnswers: ["Lanolin", "Zinc chloride", "Cetyl alcohol"],
      explanation: "Mica provides sparkle and luminous reflection (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which oxide produces white opacity?",
      correctAnswer: "Titanium dioxide",
      incorrectAnswers: ["Iron oxide red", "Carbon black", "Zinc stearate"],
      explanation:
        "Titanium dioxide increases whiteness and coverage (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product colors the lips?",
      correctAnswer: "Lipstick",
      incorrectAnswers: ["Toner", "Conditioner", "Hand wash"],
      explanation:
        "Lipsticks deliver color via pigments, oils and waxes (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What gives mascara its black shade?",
      correctAnswer: "Carbon black",
      incorrectAnswers: ["Titanium dioxide", "Red dye", "Sorbitol"],
      explanation: "Carbon black provides deep black color (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What type of product adds cheek color?",
      correctAnswer: "Blush",
      incorrectAnswers: ["Sunscreen", "Shaving foam", "Face wash"],
      explanation: "Blush uses pigments to enhance cheek tone (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product evens overall skin tone?",
      correctAnswer: "Foundation",
      incorrectAnswers: ["Shampoo", "Nail oil", "Body spray"],
      explanation: "Foundations provide uniform facial coloration (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What ingredient improves powder slip?",
      correctAnswer: "Talc",
      incorrectAnswers: ["Glycerin", "EDTA", "Stearic acid"],
      explanation: "Talc reduces drag and increases spreadability (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product highlights facial features?",
      correctAnswer: "Highlighter",
      incorrectAnswers: ["Astringent", "Hair gel", "Antiperspirant"],
      explanation: "Highlighters reflect light using mica or pearls (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What holds pressed powders together?",
      correctAnswer: "Binders",
      incorrectAnswers: ["Fragrance oils", "Chelators", "Alcohol"],
      explanation:
        "Binders help particles adhere in pressed formats (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which pigment class gives earthy tones?",
      correctAnswer: "Iron oxides",
      incorrectAnswers: ["FD&C dyes", "Bronzers", "Preservatives"],
      explanation: "Iron oxides provide stable browns and reds (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which product defines brows?",
      correctAnswer: "Brow pencil",
      incorrectAnswers: ["Lip gloss", "Body lotion", "Hair serum"],
      explanation: "Brow pencils deposit wax and pigment (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which format is a compact pigment cake?",
      correctAnswer: "Pressed powder",
      incorrectAnswers: ["Hydrogel", "Stick balm", "Aerosol foam"],
      explanation: "Pressed powders deliver buildable coverage (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What increases lipstick shine?",
      correctAnswer: "Oil level",
      incorrectAnswers: ["Salt level", "Acid value", "Fragrance load"],
      explanation: "More oil increases glossiness (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient boosts opacity?",
      correctAnswer: "Titanium dioxide",
      incorrectAnswers: ["Alpha hydroxy acid", "Sodium chloride", "Ethanol"],
      explanation: "Titanium dioxide provides strong coverage (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What makes gloss shiny?",
      correctAnswer: "Esters",
      incorrectAnswers: ["Proteins", "Salts", "Alcohols"],
      explanation: "Light esters enhance shine and spread (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which ingredient ensures uniform color?",
      correctAnswer: "Dispersants",
      incorrectAnswers: ["Preservatives", "Humectants", "Thickeners"],
      explanation: "Dispersants keep pigments evenly distributed (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "Which wax stiffens lipstick?",
      correctAnswer: "Beeswax",
      incorrectAnswers: ["Lanolin", "Dimethicone", "Butylene glycol"],
      explanation: "Waxes provide structure and stability (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What increases mascara viscosity?",
      correctAnswer: "Polymers",
      incorrectAnswers: ["EDTA", "AHAs", "Abrasives"],
      explanation: "Polymers thicken and improve lash coating (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What prevents streakiness in foundation?",
      correctAnswer: "Proper dispersion",
      incorrectAnswers: ["Extra fragrance", "More water", "Higher pH"],
      explanation: "Good dispersion keeps pigment uniform (Module 7)",
      difficulty: "Easy",
    },
    {
      text: "What is the goal of scale-up?",
      correctAnswer: "Replicate batches",
      incorrectAnswers: ["Reduce potency", "Increase scent", "Thicken color"],
      explanation:
        "Scale-up reproduces lab performance at larger size (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "Which document guides production steps?",
      correctAnswer: "Batch sheet",
      incorrectAnswers: ["Ad brief", "Invoice", "Label copy"],
      explanation: "Batch sheets outline every manufacturing step (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What equipment blends cosmetic batches?",
      correctAnswer: "Mixer",
      incorrectAnswers: ["3D printer", "Freezer", "Capper"],
      explanation: "Mixers disperse and blend ingredients (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What measures batch temperature?",
      correctAnswer: "Thermocouple",
      incorrectAnswers: ["Gloss meter", "Torque gauge", "SPF sensor"],
      explanation:
        "Thermocouples control heating and cooling phases (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What prevents ingredient dosing errors?",
      correctAnswer: "Accurate weighing",
      incorrectAnswers: ["Extra fragrance", "Large pumps", "Thicker caps"],
      explanation: "Accurate weighing ensures formula correctness (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What reduces air bubbles in batches?",
      correctAnswer: "Slow agitation",
      incorrectAnswers: ["More pigment", "Less water", "Extra scent"],
      explanation: "Slower agitation lowers entrapped air (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "Which step checks uniformity?",
      correctAnswer: "In‑process testing",
      incorrectAnswers: ["Barcode scan", "Label audit", "Carton folding"],
      explanation: "In‑process tests verify batches mid‑run (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What heats oil phases?",
      correctAnswer: "Hot plate",
      incorrectAnswers: ["Cold vault", "Inkjet head", "Tube heater"],
      explanation: "Hot plates melt waxes and oils uniformly (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What verifies ingredient identity?",
      correctAnswer: "QC testing",
      incorrectAnswers: [
        "Bottle glare test",
        "Carton flex test",
        "Logo brightness",
      ],
      explanation: "Identity tests confirm raw materials (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What ensures accurate filling?",
      correctAnswer: "Fill‑weight check",
      incorrectAnswers: [
        "Cap torque test",
        "Tube gloss check",
        "Pump color check",
      ],
      explanation: "Fill weight confirms correct delivered amount (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What cools batches evenly?",
      correctAnswer: "Controlled cooling",
      incorrectAnswers: ["High shear", "Vacuum pumping", "Tube shrink"],
      explanation: "Controlled cooling avoids instability (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "Which vessel scrapes tank walls?",
      correctAnswer: "Sweep mixer",
      incorrectAnswers: ["Static rod", "Comb blade", "Tube rail"],
      explanation: "Sweep blades prevent material buildup (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What keeps heating uniform?",
      correctAnswer: "Jacketed vessel",
      incorrectAnswers: ["Spray nozzle", "Tube sealer", "Capper arm"],
      explanation: "Jacketed vessels distribute heat evenly (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What adds powders gradually?",
      correctAnswer: "Controlled addition",
      incorrectAnswers: ["Sudden dump", "Vacuum purge", "Rapid cooling"],
      explanation: "Gradual addition prevents clumping (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What minimizes contamination risk?",
      correctAnswer: "Sanitized tanks",
      incorrectAnswers: ["Extra dyes", "Bottle tint", "Cap gloss"],
      explanation: "Proper sanitation protects product safety (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What controls tank temperature?",
      correctAnswer: "Thermostat",
      incorrectAnswers: ["Barcode", "Tube crimper", "Carton flap"],
      explanation: "Thermostats regulate heating cycles (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What verifies viscosity?",
      correctAnswer: "Viscometer",
      incorrectAnswers: ["Scale", "Gloss meter", "Crimp analyzer"],
      explanation: "Viscometers measure flow resistance (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What reduces equipment wear?",
      correctAnswer: "Proper lubrication",
      incorrectAnswers: ["Extra heat", "More pigment", "Over‑mixing"],
      explanation: "Lubrication protects moving parts (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What prevents phase separation early?",
      correctAnswer: "Proper emulsification",
      incorrectAnswers: ["Thicker labels", "Shorter tubes", "Extra fragrance"],
      explanation: "Strong emulsification stabilizes phases (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What confirms batch homogeneity?",
      correctAnswer: "Sampling",
      incorrectAnswers: ["Tube welding", "Ink curing", "Cap drying"],
      explanation: "Sampling checks uniform distribution (Module 8)",
      difficulty: "Easy",
    },
    {
      text: "What does stability testing predict?",
      correctAnswer: "Shelf life",
      incorrectAnswers: ["Tube size", "Cap color", "Carton print"],
      explanation:
        "Stability testing forecasts long‑term product behavior (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Which tool measures pH?",
      correctAnswer: "pH meter",
      incorrectAnswers: ["Viscometer", "Torque gauge", "Combimeter"],
      explanation: "A pH meter quantifies acidity or alkalinity (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What indicates an emulsion is failing?",
      correctAnswer: "Phase separation",
      incorrectAnswers: ["Mild scent change", "High shine", "Gentle foam"],
      explanation: "Separated phases signal structural breakdown (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Which test stresses formulas with heat?",
      correctAnswer: "Accelerated aging",
      incorrectAnswers: ["Panel scoring", "Tube crimping", "Fill check"],
      explanation:
        "Accelerated aging simulates long‑term conditions (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What detects microbial contamination?",
      correctAnswer: "Micro test",
      incorrectAnswers: ["Tube tilt", "Gloss read", "Barcode check"],
      explanation: "Micro tests confirm preservative effectiveness (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What causes oils to smell rancid?",
      correctAnswer: "Oxidation",
      incorrectAnswers: ["Tube trimming", "Cap welding", "UV coating"],
      explanation: "Oxidation creates off‑odors (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Which test checks packaging durability?",
      correctAnswer: "Drop test",
      incorrectAnswers: ["Color match", "Foam test", "Torque spin"],
      explanation: "Drop tests measure impact resistance (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Why perform freeze‑thaw cycles?",
      correctAnswer: "Stress emulsions",
      incorrectAnswers: [
        "Improve scent",
        "Raise color depth",
        "Lower viscosity",
      ],
      explanation: "Freeze–thaw simulates harsh conditions (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Which tool measures thickness?",
      correctAnswer: "Viscometer",
      incorrectAnswers: ["pH probe", "Colorimeter", "Lux meter"],
      explanation: "Viscometers track viscosity changes (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What does a challenge test evaluate?",
      correctAnswer: "Preservative strength",
      incorrectAnswers: ["Bottle texture", "Tube opacity", "Label shine"],
      explanation:
        "Challenge tests measure antimicrobial protection (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What reveals early haze?",
      correctAnswer: "Clarity test",
      incorrectAnswers: ["Torque test", "Flash test", "Panel rub"],
      explanation: "Clarity tests detect translucency loss (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Which factor speeds breakdown?",
      correctAnswer: "High heat",
      incorrectAnswers: ["Deep crimp", "Label gloss", "Cap emboss"],
      explanation: "Heat accelerates chemical reactions (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What signals microbial spoilage?",
      correctAnswer: "Odor change",
      incorrectAnswers: ["Carton rub", "Tube bow", "Ink scuff"],
      explanation: "Microbes often create off‑odors (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Which test measures color shift?",
      correctAnswer: "Colorimetry",
      incorrectAnswers: ["Burst test", "UV flash", "Actuator bend"],
      explanation: "Colorimeters detect shade drift (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What can cause hydrolysis?",
      correctAnswer: "High humidity",
      incorrectAnswers: ["Low airflow", "Tube shape", "Cap size"],
      explanation: "Moisture accelerates hydrolytic degradation (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What does weight loss indicate?",
      correctAnswer: "Evaporation",
      incorrectAnswers: ["Tube damage", "UV gloss", "Cap torque"],
      explanation: "Evaporation reduces product mass (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Why test samples under light?",
      correctAnswer: "Photostability",
      incorrectAnswers: ["Cap stiffness", "Tube echo", "Panel glare"],
      explanation: "Light tests show UV‑driven degradation (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "What indicates oil oxidation?",
      correctAnswer: "Rancid odor",
      incorrectAnswers: ["Tube glow", "Cap shine", "Label curl"],
      explanation: "Oxidation produces unpleasant odors (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Which test stresses closures?",
      correctAnswer: "Vibration test",
      incorrectAnswers: ["pH test", "Flash match", "Panel dye"],
      explanation: "Vibration identifies weak seals (Module 9)",
      difficulty: "Easy",
    },
    {
      text: "Which change signals instability?",
      correctAnswer: "Unexpected thickening",
      incorrectAnswers: ["Tube hue shift", "Pump length", "Label placement"],
      explanation: "Thickening can indicate structural change (Module 9)",
      difficulty: "Easy",
    },
  ],
  Medium: [
    {
      text: "Why calibrate a pH meter?",
      correctAnswer: "Accuracy",
      incorrectAnswers: [
        "Fragrance strength",
        "Viscosity build",
        "Preservative boost",
      ],
      explanation:
        "Calibration ensures readings remain accurate before use (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "What affects viscosity measurement reliability?",
      correctAnswer: "Temperature control",
      incorrectAnswers: ["Fragrance type", "Bottle shape", "Color intensity"],
      explanation: "Temperature changes alter fluid thickness (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why use an overhead stirrer instead of manual mixing?",
      correctAnswer: "Consistent shear",
      incorrectAnswers: ["Stronger fragrance", "Lower pH", "Higher gloss"],
      explanation:
        "Overhead stirrers provide uniform mixing and shear (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Which factor influences emulsification success?",
      correctAnswer: "Shear rate",
      incorrectAnswers: [
        "Fragrance choice",
        "Colorant brightness",
        "Label design",
      ],
      explanation: "Shear rate helps form small stable droplets (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why monitor cooling curves?",
      correctAnswer: "Check stability",
      incorrectAnswers: [
        "Boost foam",
        "Reduce fragrance load",
        "Improve color payoff",
      ],
      explanation:
        "Cooling profiles influence crystallization and viscosity (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Which measurement helps detect ingredient purity?",
      correctAnswer: "Refractive index",
      incorrectAnswers: ["Tube squeeze force", "Foam density", "Batch number"],
      explanation: "Refractive index can signal impurities (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why measure conductivity in water?",
      correctAnswer: "Check ion levels",
      incorrectAnswers: [
        "Test fragrance",
        "Estimate viscosity",
        "Set wax hardness",
      ],
      explanation:
        "Ions affect surfactant performance and stability (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "What does a rheology modifier affect most?",
      correctAnswer: "Flow behavior",
      incorrectAnswers: [
        "Color varnish",
        "Odor longevity",
        "Microbial kill rate",
      ],
      explanation: "Rheology modifiers alter flow and texture (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why record ambient humidity?",
      correctAnswer: "Affects powders",
      incorrectAnswers: [
        "Boosts gloss",
        "Changes fragrance name",
        "Impacts label printing",
      ],
      explanation: "Humidity influences powder flow and weight (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Which factor impacts stability during batching?",
      correctAnswer: "Order of addition",
      incorrectAnswers: ["Bottle color", "Fragrance copyright", "Cap torque"],
      explanation:
        "Order affects solubility, viscosity, and emulsification (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why is precise weighing essential?",
      correctAnswer: "Formula reproducibility",
      incorrectAnswers: [
        "Marketing appeal",
        "Color brilliance",
        "Label hierarchy",
      ],
      explanation: "Accurate weights ensure consistent results (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "What does “shear thinning” describe?",
      correctAnswer: "Viscosity drop with mixing",
      incorrectAnswers: ["Color loss", "Scent fading", "Powder settling"],
      explanation: "Shear thinning materials flow more under stress (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why take viscosity readings at timed intervals?",
      correctAnswer: "Track thickening",
      incorrectAnswers: [
        "Improve scent",
        "Adjust label",
        "Change fill weights",
      ],
      explanation: "Viscosity develops over cooling and hydration (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "What is the purpose of a water bath?",
      correctAnswer: "Controlled heating",
      incorrectAnswers: [
        "Odor removal",
        "Pigment wetting",
        "Propellant cooling",
      ],
      explanation: "Water baths heat steadily without hotspots (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why track batch temperature throughout processing?",
      correctAnswer: "Phase control",
      incorrectAnswers: ["Scent projection", "Pigment gloss", "Container tint"],
      explanation:
        "Temperature controls melting, emulsification, and thickening (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Which factor affects refractometer readings?",
      correctAnswer: "Temperature",
      incorrectAnswers: ["Jar height", "Fragrance bottle", "Foam wand"],
      explanation: "Refractive index shifts with temperature (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why use a homogenizer for some batches?",
      correctAnswer: "Small droplet size",
      incorrectAnswers: [
        "Stronger fragrance",
        "Thicker color",
        "More foam only",
      ],
      explanation:
        "High shear homogenization produces fine emulsions (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why keep glassware dry before weighing powders?",
      correctAnswer: "Accuracy",
      incorrectAnswers: ["Pigment binding", "Foam height", "Label adhesion"],
      explanation: "Moisture causes powders to clump and mis-weigh (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "What does a digital timer help ensure?",
      correctAnswer: "Process consistency",
      incorrectAnswers: [
        "Fragrance uniqueness",
        "Label placement",
        "Marketing claims",
      ],
      explanation:
        "Timing ensures repeatable mixing and heating steps (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why evaluate samples under consistent lighting?",
      correctAnswer: "Color accuracy",
      incorrectAnswers: ["pH stability", "Foam density", "Odor strength"],
      explanation:
        "Lighting affects color perception during evaluation (Module 1)",
      difficulty: "Medium",
    },
    {
      text: "Why review the marketing brief with R&D?",
      correctAnswer: "Align expectations",
      incorrectAnswers: [
        "Boost viscosity",
        "Pick fragrance bottles",
        "Set carton gloss",
      ],
      explanation:
        "R&D must align feasibility with claims and goals (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What does feasibility evaluation determine?",
      correctAnswer: "If idea is workable",
      incorrectAnswers: ["Consumer loyalty", "Tank spacing", "Pallet height"],
      explanation:
        "Feasibility checks technical and cost constraints early (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why build multiple prototype versions?",
      correctAnswer: "Compare performance",
      incorrectAnswers: [
        "Improve carton art",
        "Raise pump height",
        "Reduce freight",
      ],
      explanation:
        "Multiple variations reveal performance differences (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What influences claim selection?",
      correctAnswer: "Supporting data",
      incorrectAnswers: ["Bottle curve", "Cap embossing", "Shipping labels"],
      explanation: "Claims must match evidence from tests (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why involve packaging during early trials?",
      correctAnswer: "Avoid incompatibility",
      incorrectAnswers: [
        "Increase scent lift",
        "Add color depth",
        "Raise jar weight",
      ],
      explanation: "Packaging interactions can destabilize formulas (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What does a stage-gate review assess?",
      correctAnswer: "Progress checkpoints",
      incorrectAnswers: ["Scent longevity", "Tube rigidity", "Jar tinting"],
      explanation: "Stage-gates verify readiness to proceed (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What guides fragrance inclusion levels?",
      correctAnswer: "Regulatory limits",
      incorrectAnswers: ["Fill rate", "Cap torque", "Pouch seam strength"],
      explanation:
        "Fragrance levels must meet safety and IFRA rules (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why run consumer-in-use testing?",
      correctAnswer: "Validate experience",
      incorrectAnswers: [
        "Adjust jar color",
        "Improve pallet stacking",
        "Reduce dye cost",
      ],
      explanation:
        "Real usage reveals sensory and usability insights (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What is a common reason prototypes fail?",
      correctAnswer: "Unmet claims",
      incorrectAnswers: [
        "Bottle color drift",
        "Wrong barcode",
        "Shelf height issues",
      ],
      explanation:
        "Prototypes often fail to deliver claimed benefits (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why align R&D and marketing timelines?",
      correctAnswer: "Avoid launch delays",
      incorrectAnswers: ["Increase gloss", "Raise pH", "Deepen color"],
      explanation:
        "Development activities must fit the launch calendar (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What determines technical claim wording?",
      correctAnswer: "Regulatory guidance",
      incorrectAnswers: [
        "Bottle profile",
        "Scent volatility",
        "Nozzle diameter",
      ],
      explanation: "Claims must comply with local regulations (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why evaluate competitor ingredient lists?",
      correctAnswer: "Identify strategies",
      incorrectAnswers: ["Copy scent", "Print labels", "Foam bottles"],
      explanation:
        "Competitor analysis highlights formulation approaches (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What does cost modeling help predict?",
      correctAnswer: "Margin impact",
      incorrectAnswers: ["Tube stiffness", "Jar height", "Carton fiber"],
      explanation:
        "Margins depend on raw materials and process cost (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why run stability on early prototypes?",
      correctAnswer: "Detect weaknesses",
      incorrectAnswers: [
        "Choose cap style",
        "Pick tint strength",
        "Set pump thread",
      ],
      explanation: "Stability reveals future risks before scale-up (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Which factor increases project complexity?",
      correctAnswer: "More claims",
      incorrectAnswers: ["Fewer jars", "Lower fill temp", "Bold fonts"],
      explanation: "More claims require additional validation (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why meet with suppliers early?",
      correctAnswer: "Understand raw limits",
      incorrectAnswers: [
        "Improve palette",
        "Design labels",
        "Align fragrance story",
      ],
      explanation: "Suppliers explain constraints and alternatives (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What does “consumer insight” research provide?",
      correctAnswer: "Behavior drivers",
      incorrectAnswers: ["Carton sizes", "Pump plastics", "Tube seam width"],
      explanation: "Insights reveal motivations and unmet needs (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What supports up-front risk assessments?",
      correctAnswer: "Cross-functional input",
      incorrectAnswers: ["Jar etching", "Tube opacity", "Fragrance bottle"],
      explanation:
        "Early team input predicts development challenges (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why are performance benchmarks important?",
      correctAnswer: "Set direction",
      incorrectAnswers: [
        "Prevent pH drift",
        "Reduce propellant",
        "Improve label ink",
      ],
      explanation: "Benchmarking guides tests and target outcomes (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "What helps prevent scope creep?",
      correctAnswer: "Clear objectives",
      incorrectAnswers: ["More pigments", "Bigger caps", "Extra labels"],
      explanation: "Clear goals keep development on track (Module 2)",
      difficulty: "Medium",
    },
    {
      text: "Why include multiple emollients in a formula?",
      correctAnswer: "Better sensory profile",
      incorrectAnswers: ["Lower pH", "Boost foam only", "Increase opacity"],
      explanation:
        "Combining emollients improves texture and afterfeel (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why are fatty alcohols used in conditioners?",
      correctAnswer: "Structure and slip",
      incorrectAnswers: ["Rinse bleaching", "Foam reduction", "Color bonding"],
      explanation: "Fatty alcohols thicken and enhance conditioning (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "What is a common drawback of humectants?",
      correctAnswer: "Tackiness at high levels",
      incorrectAnswers: [
        "Color fading",
        "UV instability",
        "Preservative failure",
      ],
      explanation: "Humectants can feel sticky when overused (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why add solubilizers to fragrance? ",
      correctAnswer: "Clear dispersion",
      incorrectAnswers: ["Lower SPF", "Thicken wax", "Dissolve pigments"],
      explanation: "Solubilizers keep oils clear in water systems (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "What do cationic surfactants bond to?",
      correctAnswer: "Damaged hair",
      incorrectAnswers: ["Glassware", "Iron oxides", "Mica"],
      explanation: "Cationics bond to negatively charged surfaces (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Which factor influences emulsifier selection most?",
      correctAnswer: "Oil phase type",
      incorrectAnswers: ["Cap stiffness", "Tube varnish", "Scent bottle color"],
      explanation:
        "The oil phase impacts required HLB and system choice (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why add polymers to shampoos?",
      correctAnswer: "Improve deposition",
      incorrectAnswers: ["Raise pH", "Strengthen jars", "Reduce tint"],
      explanation: "Polymers help conditioning agents stick to hair (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why use esters in lotions?",
      correctAnswer: "Light feel",
      incorrectAnswers: ["UV curing", "Rapid bleaching", "Cap sealing"],
      explanation: "Esters add spreadability and mildness (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "What improves salt stability in surfactant systems?",
      correctAnswer: "Amphoterics",
      incorrectAnswers: ["Clays", "Powders", "Zinc plates"],
      explanation:
        "Amphoteric surfactants tolerate salt better than others (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why does glycerin thicken formulas slightly?",
      correctAnswer: "Hydrogen bonding",
      incorrectAnswers: [
        "Oil oxidation",
        "Pigment flocculation",
        "Fragrance burnout",
      ],
      explanation:
        "Glycerin interacts with water to increase viscosity (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Which ingredient helps pigments disperse evenly?",
      correctAnswer: "Wetting agent",
      incorrectAnswers: ["Humectant", "Antifoam", "Whitening resin"],
      explanation: "Wetting agents help pigments spread uniformly (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why use low-viscosity silicones?",
      correctAnswer: "Better spread",
      incorrectAnswers: [
        "Color stability",
        "Preservative boost",
        "Tubing stiffness",
      ],
      explanation: "Low-viscosity silicones improve glide and slip (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "What improves preservative performance in surfactant products?",
      correctAnswer: "Chelators",
      incorrectAnswers: ["Iron oxides", "Starches", "Silicones"],
      explanation: "Chelators remove metals that bind preservatives (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why include occlusives in moisturizers?",
      correctAnswer: "Reduce water loss",
      incorrectAnswers: ["Boost surfactant", "Increase foam", "Deepen color"],
      explanation:
        "Occlusives form a barrier slowing moisture evaporation (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "What can high clay levels cause?",
      correctAnswer: "Draggy feel",
      incorrectAnswers: ["High shine", "Better fragrance", "Lighter texture"],
      explanation: "Too much clay increases drag and dullness (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why are antioxidants used in oils?",
      correctAnswer: "Prevent rancidity",
      incorrectAnswers: [
        "Improve foam",
        "Make gels clearer",
        "Lower melting point",
      ],
      explanation: "Antioxidants slow oxidation of oily ingredients (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "What is a typical issue with waxes?",
      correctAnswer: "Crystallization drift",
      incorrectAnswers: [
        "Low conductivity",
        "Reduced SPF",
        "Preservative shock",
      ],
      explanation: "Waxes can crystallize unpredictably on cooling (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why select mild surfactants for facial cleansers?",
      correctAnswer: "Lower irritation",
      incorrectAnswers: ["More gloss", "Heavy deposition", "Tube adhesion"],
      explanation: "Mild surfactants reduce barrier disruption (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "What helps prevent phase separation?",
      correctAnswer: "Proper HLB balance",
      incorrectAnswers: ["More fragrance", "Extra dyes", "Less mixing"],
      explanation:
        "Matching HLB to oil phase improves emulsion stability (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "Why do some silicones resist wash-off?",
      correctAnswer: "Hydrophobicity",
      incorrectAnswers: ["High pH", "Low charge", "Thick texture"],
      explanation:
        "Silicones strongly repel water due to hydrophobic structure (Module 3)",
      difficulty: "Medium",
    },
    {
      text: "What mainly distinguishes creams from lotions?",
      correctAnswer: "Viscosity",
      incorrectAnswers: ["Preservative type", "pH range", "Color"],
      explanation:
        "Creams are higher viscosity emulsions than lotions (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Why are solutions generally easy to manufacture?",
      correctAnswer: "Few phases",
      incorrectAnswers: [
        "No preservatives needed",
        "No mixing needed",
        "No raw data needed",
      ],
      explanation:
        "They contain one continuous phase and dissolve ingredients (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "What key parameter defines an emulsion’s internal phase?",
      correctAnswer: "Dispersed phase",
      incorrectAnswers: ["Color", "Scent", "Packaging shape"],
      explanation:
        "The internal phase is the dispersed droplet phase (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which product type typically uses carbomer gels?",
      correctAnswer: "Styling gels",
      incorrectAnswers: ["Aerosol sprays", "Loose powders", "Sticks"],
      explanation:
        "Hair styling products often use carbomer gel networks (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Why are ointments often difficult to wash off?",
      correctAnswer: "High hydrophobic load",
      incorrectAnswers: ["Low pH", "High alcohol", "Low solids"],
      explanation:
        "Ointments contain large amounts of hydrophobic materials (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which form often needs specialized filling equipment?",
      correctAnswer: "Aerosols",
      incorrectAnswers: ["Solutions", "Lotions", "Gels"],
      explanation: "Aerosols require pressure-rated cans and valves (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Why do sticks require careful melting profiles?",
      correctAnswer: "Control recrystallization",
      incorrectAnswers: [
        "Improve fragrance",
        "Lower pH",
        "Boost color strength",
      ],
      explanation:
        "Melting and cooling profiles control wax structure (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which form can easily separate into two clear layers?",
      correctAnswer: "Emulsion",
      incorrectAnswers: ["Powder", "Tablet", "Stick"],
      explanation:
        "Unstable emulsions phase separate into oil and water (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which form is most sensitive to powder flow properties?",
      correctAnswer: "Pressed powders",
      incorrectAnswers: ["Lotions", "Solutions", "Gels"],
      explanation:
        "Pressed powders rely on good powder flow and packing (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Why are aerosols sometimes regulated for VOC content?",
      correctAnswer: "Air quality impact",
      incorrectAnswers: ["Skin irritation", "Color bleeding", "pH drift"],
      explanation:
        "Propellants and solvents can contribute to VOC emissions (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which system is best when uniform active dosing is critical?",
      correctAnswer: "Solution",
      incorrectAnswers: ["Stick", "Loose powder", "Ointment"],
      explanation:
        "Solutions give uniform concentration at every dose (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "What is a drawback of solution-only formulations?",
      correctAnswer: "Limited richness",
      incorrectAnswers: [
        "Poor clarity",
        "High powder load",
        "Difficult filling",
      ],
      explanation:
        "Solutions feel less rich than emulsions or ointments (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Why are gels good for clear styling products?",
      correctAnswer: "High clarity",
      incorrectAnswers: ["Low preservative", "No mixing", "No humidity impact"],
      explanation: "Properly neutralized gels can be water clear (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "What helps ointments stay on localized areas?",
      correctAnswer: "High viscosity",
      incorrectAnswers: ["Low density", "High color", "Low preservative"],
      explanation:
        "Ointments have very high viscosity and do not run (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which form is ideal for travel-friendly solid cleansers?",
      correctAnswer: "Bars or sticks",
      incorrectAnswers: ["Gels", "Aerosols", "Loose powders"],
      explanation: "Bars and sticks reduce leakage risk in travel (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Why are aerosols convenient for even coverage?",
      correctAnswer: "Fine mist",
      incorrectAnswers: [
        "High color strength",
        "Low density",
        "Minimal propellant",
      ],
      explanation:
        "Spray mists distribute product uniformly on surfaces (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which form best masks gritty actives in skin care?",
      correctAnswer: "Emulsion cream",
      incorrectAnswers: ["Loose powder", "Tablet", "Stick"],
      explanation:
        "Cream emulsions can hide gritty particles in the matrix (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which format is often used for bath fizzers?",
      correctAnswer: "Tablets",
      incorrectAnswers: ["Solutions", "Gels", "Ointments"],
      explanation: "Bath bombs are compressed powder tablets (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Why are sticks sensitive to ambient temperature?",
      correctAnswer: "Wax melting point",
      incorrectAnswers: ["Fragrance volatility", "pH shift", "Water hardness"],
      explanation:
        "Sticks soften or harden depending on wax melting ranges (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Which form most often needs suspension aids for pigments?",
      correctAnswer: "Gels and creams",
      incorrectAnswers: ["Tablets only", "Solutions only", "Aerosols only"],
      explanation:
        "Gels and emulsions often need suspending systems for pigments (Module 4)",
      difficulty: "Medium",
    },
    {
      text: "Why do shampoos often include amphoteric surfactants?",
      correctAnswer: "Boost mildness",
      incorrectAnswers: ["Increase hardness", "Add fragrance", "Raise pH"],
      explanation:
        "Amphoterics reduce irritation and improve foam quality (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which ingredient type is best for deep conditioning?",
      correctAnswer: "Cationic surfactants",
      incorrectAnswers: ["Simple salts", "Short chain alcohols", "Inert gases"],
      explanation:
        "Cationic surfactants bond strongly to damaged hair (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Why might a conditioner feel heavy on fine hair?",
      correctAnswer: "Too much oil",
      incorrectAnswers: ["Too many chelators", "Low fragrance", "High pH"],
      explanation: "High oil or silicone levels can weigh hair down (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which surfactant combination improves shampoo mildness?",
      correctAnswer: "Anionic plus amphoteric",
      incorrectAnswers: [
        "Only strong anionic",
        "Only solvent",
        "Only thickener",
      ],
      explanation:
        "Blending mild amphoterics with anionics reduces harshness (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Why include pearlescent agents in shampoos?",
      correctAnswer: "Aesthetic appeal",
      incorrectAnswers: ["More preservation", "Lower pH", "Reduce viscosity"],
      explanation:
        "They create visual cues of richness and conditioning (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which ingredient can add hold and humidity resistance?",
      correctAnswer: "Styling polymer",
      incorrectAnswers: ["Preservative", "Chelator", "Colorant"],
      explanation:
        "Acrylate-based resins provide hold and humidity resistance (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Why do anti-dandruff shampoos need specific actives?",
      correctAnswer: "Control fungi",
      incorrectAnswers: ["Boost lather", "Brighten color", "Thicken gels"],
      explanation:
        "Actives like zinc pyrithione address Malassezia species (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "What is a drawback of frequent clarifying shampoo use?",
      correctAnswer: "Increased dryness",
      incorrectAnswers: [
        "Permanent coloring",
        "Hair straightening",
        "Fragrance loss only",
      ],
      explanation:
        "Aggressive cleansing can strip beneficial lipids and conditioners (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which parameter is key for conditioner deposition?",
      correctAnswer: "Charge interactions",
      incorrectAnswers: ["Bottle color", "Fragrance cost", "Fill speed"],
      explanation:
        "Cationic ingredients deposit due to opposite charge on hair (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Why are some conditioners formulated as water in oil?",
      correctAnswer: "Extra richness",
      incorrectAnswers: [
        "More bubbles",
        "Brighter color",
        "Easier aerosol filling",
      ],
      explanation:
        "Water in oil systems can feel richer and more occlusive (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which styling form is best for very defined curls?",
      correctAnswer: "Cream gel",
      incorrectAnswers: ["Dry shampoo", "Body lotion", "Hand sanitizer"],
      explanation:
        "Cream gels combine conditioning and hold for curls (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Why are silicones sometimes modified to be water dispersible?",
      correctAnswer: "Improve shampoo compatibility",
      incorrectAnswers: [
        "Increase hardness",
        "Color hair",
        "Act as propellant",
      ],
      explanation:
        "Water dispersible silicones deposit from surfactant systems (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "What hair issue do moisturizing shampoos primarily address?",
      correctAnswer: "Dryness",
      incorrectAnswers: ["Gray coverage", "Straightening", "Permanent color"],
      explanation: "They aim to reduce dryness while cleansing (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which ingredient reduces static in hair?",
      correctAnswer: "Cationic polymer",
      incorrectAnswers: ["Sodium chloride", "Citric acid", "Petrolatum only"],
      explanation:
        "Cationic polymers neutralize static charges on hair (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Why might a 2-in-1 shampoo be challenging to formulate?",
      correctAnswer: "Balance cleanse and condition",
      incorrectAnswers: [
        "Avoid any surfactants",
        "Exclude polymers",
        "Eliminate fragrance",
      ],
      explanation:
        "It must clean yet deposit enough conditioning agents (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which styling product form is best for high hold aerosols?",
      correctAnswer: "Hair spray",
      incorrectAnswers: ["Mousse", "Gel", "Cream"],
      explanation:
        "Aerosol hair sprays deliver strong hold via resins (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Why can heavy styling waxes be difficult to remove?",
      correctAnswer: "Hydrophobicity",
      incorrectAnswers: ["Low fragrance", "High pigment", "Weak preservative"],
      explanation: "High wax and oil loads resist shampoo removal (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which property is key for detangling wet hair?",
      correctAnswer: "Low friction",
      incorrectAnswers: ["High hardness", "Strong fragrance", "Bright color"],
      explanation:
        "Conditioners should reduce friction during combing (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Why are conditioning masks often left on longer?",
      correctAnswer: "More penetration time",
      incorrectAnswers: [
        "Increase foam",
        "Raise pH quickly",
        "Boost fragrance volatility",
      ],
      explanation:
        "Longer contact helps actives and oils work effectively (Module 5)",
      difficulty: "Medium",
    },
    {
      text: "Which ingredient type is avoided in color-safe shampoos?",
      correctAnswer: "Harsh surfactants",
      incorrectAnswers: [
        "Cationic gums",
        "Preservatives",
        "Fragrance solvents",
      ],
      explanation: "Very harsh surfactants accelerate color fading (Module 5)",
      difficulty: "Medium",
    },
  ],
  Hard: [
    {
      text: "What causes drift in pH measurements?",
      correctAnswer: "Electrode fouling",
      incorrectAnswers: [
        "High viscosity",
        "Label ink bleed",
        "Cap thread wear",
      ],
      explanation: "Fouled electrodes produce unstable pH readings (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why measure viscosity at multiple shear rates?",
      correctAnswer: "Characterize rheology",
      incorrectAnswers: [
        "Increase gloss",
        "Improve fragrance",
        "Check valve fit",
      ],
      explanation:
        "Rheology requires measuring flow under different shear (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Which factor most affects homogenization efficiency?",
      correctAnswer: "Shear energy",
      incorrectAnswers: ["Fragrance polarity", "Label coating", "Powder tint"],
      explanation: "Shear energy controls droplet size reduction (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why must electrodes stay hydrated?",
      correctAnswer: "Maintain sensitivity",
      incorrectAnswers: [
        "Increase foam",
        "Reduce color fade",
        "Improve scent throw",
      ],
      explanation: "Hydrated electrodes give accurate response (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "What error results from weighing warm samples?",
      correctAnswer: "Evaporation loss",
      incorrectAnswers: ["Color shift", "Rapid foaming", "Jar embossing"],
      explanation:
        "Warm volatile materials evaporate during weighing (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why monitor both heating and cooling ramps?",
      correctAnswer: "Predict structure",
      incorrectAnswers: [
        "Enhance fragrance",
        "Match pump height",
        "Reduce label curl",
      ],
      explanation:
        "Structure forms during heating and cooling cycles (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Which condition most disrupts viscosity readings?",
      correctAnswer: "Air bubbles",
      incorrectAnswers: [
        "Strong perfume",
        "High label gloss",
        "Wide tube diameter",
      ],
      explanation: "Air entrainment corrupts torque-based measures (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why standardize spindle selection?",
      correctAnswer: "Comparable data",
      incorrectAnswers: [
        "Lower fill cost",
        "Increase gloss",
        "Simplify artwork",
      ],
      explanation: "Using the same spindle ensures data consistency (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "What causes refractive index mismatch in solutions?",
      correctAnswer: "Undissolved solids",
      incorrectAnswers: ["Label glare", "Pump stiffness", "Cap lubricant"],
      explanation: "Undissolved matter alters light bending (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why record shear history of samples?",
      correctAnswer: "Affects viscosity",
      incorrectAnswers: ["Alters scent", "Changes hue", "Impacts fill weight"],
      explanation: "Viscosity depends on previous shear exposure (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Which factor compromises homogenizer performance?",
      correctAnswer: "Worn blade",
      incorrectAnswers: ["Scent profile", "Label embossing", "Pump spring"],
      explanation: "Worn blades reduce effective shear (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why use low-draft balances?",
      correctAnswer: "Reduce airflow error",
      incorrectAnswers: [
        "Increase scent throw",
        "Improve gloss",
        "Prevent fading",
      ],
      explanation: "Airflow affects precision weighing (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "What leads to inconsistent batch replication?",
      correctAnswer: "Uncontrolled process variables",
      incorrectAnswers: ["Tube color", "Fragrance name", "Carton laminate"],
      explanation: "Variations in mixing and heating alter outcomes (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why must phase temperatures match before emulsifying?",
      correctAnswer: "Prevent shock separation",
      incorrectAnswers: [
        "Improve perfume lifting",
        "Enhance color play",
        "Lighten package weight",
      ],
      explanation: "Temperature mismatch destabilizes emulsions (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Which factor alters conductivity readings most?",
      correctAnswer: "Ionic strength",
      incorrectAnswers: ["Powder tint", "Wick length", "Jar opacity"],
      explanation: "Conductivity depends on ion concentration (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why are timed shear steps important?",
      correctAnswer: "Control droplet size",
      incorrectAnswers: [
        "Maximize gloss",
        "Reduce scent aging",
        "Increase cap torque",
      ],
      explanation:
        "Specific shear durations determine droplet uniformity (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "What issue occurs if cooling is too slow?",
      correctAnswer: "Large crystals",
      incorrectAnswers: ["Strong odor", "Color inversion", "Shelf bowing"],
      explanation: "Slow cooling allows excessive crystallization (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why use a water-jacketed vessel?",
      correctAnswer: "Thermal uniformity",
      incorrectAnswers: [
        "Label stability",
        "Scent dilution",
        "Cap lubrication",
      ],
      explanation: "Water jackets maintain stable temperature (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "What risk arises from poor glassware rinsing?",
      correctAnswer: "Cross contamination",
      incorrectAnswers: ["Gloss loss", "Bubble echo", "Color glare"],
      explanation: "Leftover residue alters formulation results (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why perform duplicate measurements?",
      correctAnswer: "Verify repeatability",
      incorrectAnswers: [
        "Increase scent intensity",
        "Reduce fill weight",
        "Lower dye cost",
      ],
      explanation: "Repeat measures confirm the method is reliable (Module 1)",
      difficulty: "Hard",
    },
    {
      text: "Why can aggressive claims stall launches?",
      correctAnswer: "Regulatory risk",
      incorrectAnswers: [
        "Batch color drift",
        "Label misalignment",
        "Valve noise",
      ],
      explanation: "Strong claims may classify a product as a drug (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What complicates cost reduction late in development?",
      correctAnswer: "Formula revalidation",
      incorrectAnswers: [
        "Pump decoration",
        "Carton color shifts",
        "Barcode spacing",
      ],
      explanation:
        "Changing materials requires new testing and approvals (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why are multi-country launches challenging?",
      correctAnswer: "Varying regulations",
      incorrectAnswers: [
        "Tank diameter",
        "Scent bottle shape",
        "Foil thickness",
      ],
      explanation: "Regulatory requirements differ by region (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What risk arises from excessive claims testing?",
      correctAnswer: "Timeline slip",
      incorrectAnswers: ["Cap stripping", "Tube warping", "Label smearing"],
      explanation: "Extra testing can delay validation stages (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What limits creativity in concept expansion?",
      correctAnswer: "Feasibility constraints",
      incorrectAnswers: [
        "Carton gradients",
        "Valve shading",
        "Label varnish limits",
      ],
      explanation: "Ideas must remain technically manufacturable (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why must marketing share precise product claims early?",
      correctAnswer: "Define testing plan",
      incorrectAnswers: ["Lower propellant", "Raise odor", "Reduce pH drift"],
      explanation: "Claims dictate what testing is required (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why can supplier changes jeopardize timelines?",
      correctAnswer: "Requalification need",
      incorrectAnswers: [
        "Carton redesign",
        "Ink migration",
        "Pump discoloration",
      ],
      explanation:
        "New materials require validation and stability checks (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What issue arises when too many claim variants exist?",
      correctAnswer: "Complexity burden",
      incorrectAnswers: [
        "Tube stiffness",
        "Scent shadowing",
        "Pallet friction",
      ],
      explanation: "More claims increase testing, artwork, and risk (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What makes a brief “non-actionable” for R&D?",
      correctAnswer: "Lack of specifics",
      incorrectAnswers: ["Strong fragrance", "Wide jar rim", "Tall pumps"],
      explanation: "Vague objectives prevent formulation direction (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why evaluate consumer pain points deeply?",
      correctAnswer: "Define real needs",
      incorrectAnswers: [
        "Raise scent load",
        "Pick cap color",
        "Boost carton shine",
      ],
      explanation:
        "Understanding real problems shapes concept value (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What can invalidate competitor comparisons?",
      correctAnswer: "Mismatched conditions",
      incorrectAnswers: ["Tube color shifts", "Bottle height", "Cap threading"],
      explanation: "Tests must match application conditions exactly (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why produce multiple stability batches?",
      correctAnswer: "Assess variability",
      incorrectAnswers: [
        "Reduce fragrance",
        "Simplify carton",
        "Lower cap torque",
      ],
      explanation: "Multiple batches show process consistency (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Which factor most complicates feasibility?",
      correctAnswer: "Conflicting requirements",
      incorrectAnswers: ["Label gloss", "Scent naming", "Tamper band type"],
      explanation: "Requirements can contradict each other (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why are claim substantiation protocols strict?",
      correctAnswer: "Legal defense",
      incorrectAnswers: ["Tube fit", "Pump airless design", "Cap radius"],
      explanation: "Strong data protects from regulatory challenges (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What creates tension between Marketing and R&D?",
      correctAnswer: "Trade-offs needed",
      incorrectAnswers: ["Tube anodizing", "Cap embossing", "Pallet stacking"],
      explanation:
        "Marketing wants benefits R&D must technically achieve (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why conduct post-launch monitoring?",
      correctAnswer: "Real-world issues",
      incorrectAnswers: ["Tube colors", "Scent bottle trends", "Carton fibers"],
      explanation: "Products can behave differently with consumers (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What is the risk of unclear consumer segmentation?",
      correctAnswer: "Wrong positioning",
      incorrectAnswers: ["Wrong barcode", "Jar shrinkage", "Tubing rupture"],
      explanation:
        "Without segmentation  the product doesn't resonate (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "What happens when timelines compress unexpectedly?",
      correctAnswer: "Reduced testing",
      incorrectAnswers: [
        "Stronger fragrance",
        "Lower jar weight",
        "Shorter tube seam",
      ],
      explanation:
        "Shortened timelines reduce validation opportunities (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why review claims after stability results?",
      correctAnswer: "Check alignment",
      incorrectAnswers: [
        "Boost color",
        "Increase jar shine",
        "Lower foam height",
      ],
      explanation: "Performance must still match promised benefits (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why can “trend-driven” briefs be risky?",
      correctAnswer: "Unstable longevity",
      incorrectAnswers: [
        "Shorter tube life",
        "Ink curing shifts",
        "Cap softening",
      ],
      explanation: "Trend ideas may peak too quickly (Module 2)",
      difficulty: "Hard",
    },
    {
      text: "Why do high-electrolyte systems destabilize some emulsifiers?",
      correctAnswer: "Charge interference",
      incorrectAnswers: ["Color shift", "Pump drag", "Tube swelling"],
      explanation:
        "Electrolytes disrupt ionic emulsifiers’ structure (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "What issue arises when carbomer is under-neutralized?",
      correctAnswer: "Low viscosity",
      incorrectAnswers: ["High foaming", "Color migration", "Scent bleaching"],
      explanation:
        "Carbomer requires neutralization to build viscosity (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why can high silicone levels hinder deposition?",
      correctAnswer: "Low affinity",
      incorrectAnswers: ["Excess charge", "Salt loading", "Volatile staining"],
      explanation:
        "Too much silicone reduces adherence to hair/skin (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "What causes pigment flotation in emulsions?",
      correctAnswer: "Density mismatch",
      incorrectAnswers: ["Low fragrance", "Tube torque", "Carton scuffing"],
      explanation: "Pigments float if density differs from matrix (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why do natural oils oxidize faster?",
      correctAnswer: "Unsaturation",
      incorrectAnswers: ["High pH", "Strong cationics", "Tube embossing"],
      explanation: "Unsaturated bonds oxidize easily (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why might an emollient suppress foam?",
      correctAnswer: "Surface competition",
      incorrectAnswers: ["Cap slip", "Color load", "Wax shading"],
      explanation:
        "Emollients compete with surfactants at interfaces (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "What makes some preservatives ineffective in surfactants?",
      correctAnswer: "Micelle binding",
      incorrectAnswers: ["Scent drift", "Jar fogging", "Tube bending"],
      explanation: "Preservatives trapped in micelles lose activity (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why avoid strong acids with proteins?",
      correctAnswer: "Denaturation",
      incorrectAnswers: ["Wax bloom", "Foam inversion", "Label warping"],
      explanation: "Acids unfold proteins and reduce performance (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why do highly polar solvents thin emulsions?",
      correctAnswer: "Phase disruption",
      incorrectAnswers: [
        "Color reflectance",
        "Pump hissing",
        "Tube lamination",
      ],
      explanation: "Polar solvents weaken oil–water structure (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why can clay thickeners destabilize silicones?",
      correctAnswer: "Adsorption",
      incorrectAnswers: ["Oxidation", "Heat tinting", "Cap shrinkage"],
      explanation:
        "Clays can adsorb silicones and disrupt structure (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why must emulsifier HLB match the oil blend?",
      correctAnswer: "Correct droplet formation",
      incorrectAnswers: [
        "Better fragrance",
        "Higher tint",
        "Lower pump stress",
      ],
      explanation: "Wrong HLB causes unstable emulsions (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why add co-surfactants?",
      correctAnswer: "Lower interfacial tension",
      incorrectAnswers: [
        "Color stabilizing",
        "Jar hardening",
        "Pump lubrication",
      ],
      explanation: "Co-surfactants assist droplet formation (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "What leads to carbomer stringiness?",
      correctAnswer: "Over-neutralization",
      incorrectAnswers: ["Shear thinning only", "Powder wetting", "Fat bloom"],
      explanation: "Too much neutralizer over-thickens carbomer (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why reduce glycerin in cold-weather formulas?",
      correctAnswer: "Crystallization risk",
      incorrectAnswers: ["Color fading", "Foam damping", "Tube flutter"],
      explanation: "Glycerin can crystallize in freezing conditions (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why do some thickeners fail in high-alcohol systems?",
      correctAnswer: "Solubility limits",
      incorrectAnswers: ["Color angle", "Tube geometry", "Cap wicking"],
      explanation: "Many polymers collapse in alcohol (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why do cationic surfactants destabilize anionic gels?",
      correctAnswer: "Charge neutralization",
      incorrectAnswers: ["Batch tint", "Pump glide", "Tube fogging"],
      explanation: "Opposite charges reduce gel structure (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why incorporate volatile silicones?",
      correctAnswer: "Fast drydown",
      incorrectAnswers: ["Color boost", "Jar clarity", "Label durability"],
      explanation:
        "Volatile silicones evaporate quickly for light feel (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why can excessive wax cause graininess?",
      correctAnswer: "Large crystals",
      incorrectAnswers: ["Scent loss", "Tube lean", "Cap noise"],
      explanation:
        "Waxes crystallize into visible grains if cooled poorly (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "Why add antioxidant + chelator together?",
      correctAnswer: "Dual protection",
      incorrectAnswers: ["Viscosity build", "Foam shaping", "Tube slip"],
      explanation:
        "Antioxidants slow oxidation  chelators remove metal catalysts (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "What causes gel syneresis?",
      correctAnswer: "Network contraction",
      incorrectAnswers: ["Low tint", "Fragrance shadow", "Tubing lift"],
      explanation:
        "Gels shrink and expel water when networks tighten (Module 3)",
      difficulty: "Hard",
    },
    {
      text: "What happens when emulsion internal phase volume gets very high?",
      correctAnswer: "Viscosity increases",
      incorrectAnswers: [
        "pH always drops",
        "Color intensifies",
        "Propellant separates",
      ],
      explanation:
        "High internal phase emulsions become very viscous (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "What main risk arises in aerosol hair sprays?",
      correctAnswer: "Flammability",
      incorrectAnswers: [
        "pH failure",
        "Excess powder caking",
        "Immediate rancidity",
      ],
      explanation:
        "Hydroalcoholic aerosols are often highly flammable (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why might a gel collapse during freeze–thaw testing?",
      correctAnswer: "Polymer network damage",
      incorrectAnswers: [
        "Preservative loss",
        "Fragrance oxidation",
        "Pigment settling",
      ],
      explanation:
        "Ice crystal formation can disrupt gel polymer networks (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "What problem occurs when wax network crystallinity is poor?",
      correctAnswer: "Stick sweating",
      incorrectAnswers: ["Excess foam", "Color fading", "Rapid pH drift"],
      explanation:
        "Poor crystallinity can cause oil bleed or sweating in sticks (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why are high internal phase emulsions challenging to process?",
      correctAnswer: "Require strong shear",
      incorrectAnswers: [
        "Need no mixing",
        "Avoid any heating",
        "Need no emulsifier",
      ],
      explanation:
        "They require high shear and careful addition profiles (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "What factor mainly controls powder compaction in pressed cakes?",
      correctAnswer: "Particle size distribution",
      incorrectAnswers: ["Fragrance level", "pH range", "Water hardness"],
      explanation:
        "Particle size and distribution determine packing and strength (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why do some solution perfumes become cloudy when cooled?",
      correctAnswer: "Fragrance solubility loss",
      incorrectAnswers: [
        "Rapid oxidation",
        "pH neutralization",
        "Propellant leakage",
      ],
      explanation:
        "Fragrance components can fall out when solubility decreases (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "What failure mode appears as oil droplets floating to the top?",
      correctAnswer: "Creaming",
      incorrectAnswers: ["Sedimentation", "Syneresis", "Blooming"],
      explanation:
        "Creaming is upward migration of droplets under gravity (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why are nonionic emulsifiers often preferred in electrolyte systems?",
      correctAnswer: "Salt tolerance",
      incorrectAnswers: [
        "High color strength",
        "Lower fragrance cost",
        "Higher pH",
      ],
      explanation: "Nonionics are less sensitive to added salts (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "What parameter is critical when filling hot-pour sticks?",
      correctAnswer: "Cooling rate",
      incorrectAnswers: ["Foam height", "Preservative load", "Tablet hardness"],
      explanation:
        "Cooling rate affects crystal size and stick strength (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why might an aerosol valve clog over time?",
      correctAnswer: "Suspended solids",
      incorrectAnswers: ["Low propellant", "High pH", "High water hardness"],
      explanation:
        "Insoluble solids can accumulate and block orifices (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Which structural feature gives gels yield value?",
      correctAnswer: "Three dimensional network",
      incorrectAnswers: [
        "High alcohol content",
        "Dense fragrance",
        "Large propellant space",
      ],
      explanation:
        "Crosslinked polymer networks impart yield stress (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "What processing step improves pigment dispersion in sticks?",
      correctAnswer: "Three roll milling",
      incorrectAnswers: ["Freeze drying", "Simple settling", "Gentle shaking"],
      explanation: "High shear milling distributes pigments evenly (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why do ointments resist microbial contamination less than emulsions?",
      correctAnswer: "Low water activity",
      incorrectAnswers: ["High fragrance", "Low wax", "High pigment"],
      explanation:
        "Ointments often have very little available water (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why must powders be dry before tablet compression?",
      correctAnswer: "Prevent capping",
      incorrectAnswers: ["Increase fragrance", "Raise pH", "Create foam"],
      explanation:
        "Residual moisture can cause tablet capping or sticking (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "What rheological property is desirable in pouring lotions?",
      correctAnswer: "Shear thinning",
      incorrectAnswers: [
        "Perfect elasticity",
        "Strong dilatancy",
        "Zero viscosity",
      ],
      explanation:
        "Shear thinning allows easy pouring yet good stand-up (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why might a cream show ringed separation in jars?",
      correctAnswer: "Poor emulsion stability",
      incorrectAnswers: ["Low fragrance", "Too many chelators", "Excess dyes"],
      explanation:
        "Phase separation often appears as rings or pools (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "What issue arises if tablet binders are too weak?",
      correctAnswer: "Crumbing",
      incorrectAnswers: [
        "Foaming",
        "Color over-development",
        "Rapid oxidation",
      ],
      explanation:
        "Poor binding leads to friable, crumbling tablets (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why are aerosols sometimes formulated as concentrates plus propellant?",
      correctAnswer: "Optimize spray quality",
      incorrectAnswers: [
        "Reduce powder flow",
        "Avoid any preservatives",
        "Increase tablet hardness",
      ],
      explanation:
        "Concentrate plus propellant balances spray rate and delivery (Module 4)",
      difficulty: "Hard",
    },
    {
      text: "Why are sulfate-free shampoos often less foamy?",
      correctAnswer: "Milder surfactants",
      incorrectAnswers: [
        "Lack of propellant",
        "No preservatives",
        "High pigment levels",
      ],
      explanation:
        "Alternative surfactants foam less than sulfates at equal levels (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "What drives polymer selection in styling gels?",
      correctAnswer: "Desired hold profile",
      incorrectAnswers: ["Bottle color", "Fragrance supplier", "Carton weight"],
      explanation:
        "Different polymers give flexible, crunchy or strong hold (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why do cationic surfactants reduce shampoo foaming?",
      correctAnswer: "Complex with anionics",
      incorrectAnswers: [
        "Evaporate quickly",
        "Increase viscosity only",
        "Neutralize fragrance",
      ],
      explanation:
        "Cationics can form complexes with anionics, reducing foam (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "What issue arises from high silicone build-up?",
      correctAnswer: "Dullness",
      incorrectAnswers: [
        "Permanent straightening",
        "Severe bleaching",
        "Scalp staining",
      ],
      explanation:
        "Excess silicone can leave hair looking dull or heavy (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Which factor most influences conditioning on damaged hair?",
      correctAnswer: "Surface charge density",
      incorrectAnswers: ["Fragrance strength", "Bottle material", "Dye type"],
      explanation:
        "Damaged hair has more negative sites for cationics (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why add fatty alcohols to conditioners?",
      correctAnswer: "Structure and richness",
      incorrectAnswers: [
        "Increase color pay-off",
        "Boost propellant",
        "Dissolve zinc salts",
      ],
      explanation: "They help thicken and improve sensory feel (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why is pH control important in permanent hair color?",
      correctAnswer: "Enable oxidation",
      incorrectAnswers: [
        "Improve perfume",
        "Deposit glitter",
        "Reduce aerosol pressure",
      ],
      explanation:
        "Alkaline pH swells hair and activates dye chemistry (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "What problem can over-neutralization of styling gel polymers cause?",
      correctAnswer: "Too thin",
      incorrectAnswers: [
        "Instant flaking",
        "Immediate oxidation",
        "Permanent stiffness",
      ],
      explanation:
        "Excess neutralization can lower viscosity and reduce hold (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why are some resins delivered as emulsions instead of solutions?",
      correctAnswer: "Lower VOCs",
      incorrectAnswers: [
        "Increase fragrance",
        "Simplify color",
        "Avoid viscosity change",
      ],
      explanation: "Emulsions reduce solvent levels and VOC content (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Which property of hair influences surfactant adsorption most?",
      correctAnswer: "Hydrophobic surface",
      incorrectAnswers: ["Core density", "Natural color", "Tip diameter"],
      explanation:
        "The hydrophobic surface interacts strongly with surfactants (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why are silicone macroemulsions sometimes preferred over microemulsions?",
      correctAnswer: "Different deposition profile",
      incorrectAnswers: [
        "Lower preservation",
        "No emulsifier need",
        "Higher propellant compatibility",
      ],
      explanation: "Droplet size influences deposition and feel (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "What risk occurs using strong chelators in hair color?",
      correctAnswer: "Altered dye kinetics",
      incorrectAnswers: [
        "Complete bleaching",
        "Instant straightening",
        "Heavy foaming only",
      ],
      explanation:
        "Chelators can change metal-catalyzed color formation (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why can conditioning agents reduce volume on fine hair?",
      correctAnswer: "Increase fiber-to-fiber adhesion",
      incorrectAnswers: ["Shorten fibers", "Strip cuticle", "Bleach melanin"],
      explanation: "They cause hairs to lie closer together (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "What problem appears as white flakes from styling products?",
      correctAnswer: "Polymer flaking",
      incorrectAnswers: [
        "Microbial growth",
        "Metal contamination",
        "Surfactant hydrolysis",
      ],
      explanation: "Incompatible resins can dry and flake from hair (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why are anhydrous pomades stable toward microbial growth?",
      correctAnswer: "No available water",
      incorrectAnswers: ["High perfume", "High dye", "Neutral pH"],
      explanation:
        "Microbes need water, absent in anhydrous systems (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "What is a key challenge in 3-in-1 hair products?",
      correctAnswer: "Conflicting performance goals",
      incorrectAnswers: [
        "Valve selection",
        "Tube printing",
        "Cap color choices",
      ],
      explanation:
        "Cleaning, conditioning and styling benefits all compete (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why can harsh shampoos increase hair breakage over time?",
      correctAnswer: "Cuticle erosion",
      incorrectAnswers: ["Melanin loss", "Root shrinking", "Pigment plating"],
      explanation: "Strong surfactants and friction damage cuticles (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "What is the primary reason to add UV filters to hair products?",
      correctAnswer: "Protect color",
      incorrectAnswers: [
        "Increase stiffness",
        "Lower density",
        "Improve fragrance strength",
      ],
      explanation:
        "UV filters help reduce photo-bleaching of hair color (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "Why might cationic conditioners be incompatible with anionic styling resins?",
      correctAnswer: "Opposite charges interact",
      incorrectAnswers: [
        "Both evaporate",
        "Both oxidize quickly",
        "Both freeze easily",
      ],
      explanation:
        "Opposite charges can cause precipitation or flocculation (Module 5)",
      difficulty: "Hard",
    },
    {
      text: "What drives the need for different shampoo variants in a line?",
      correctAnswer: "Consumer segmentation",
      incorrectAnswers: [
        "Regulatory demand",
        "Valve suppliers",
        "Carton printing",
      ],
      explanation:
        "Different hair problems require tailored surfactant and conditioning systems (Module 5)",
      difficulty: "Hard",
    },
  ],
};
